import React from 'react'

import SelectProceduresAndCIDLayout from 'presentation/doctor/layouts/AddSurgicalOrderNew/SelectProceduresAndCID'

const SelectProceduresAndCID = () => <SelectProceduresAndCIDLayout />

export default SelectProceduresAndCID
